import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Stack } from "@mui/material";

export default function UserAccountDeactivateConfirm(props) {
  const {
    open,
    setAccountActiveChange,
    userAccountDeactivateConfirmFunc
  } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleChangeyes = () => {
    setAccountActiveChange(false);
    userAccountDeactivateConfirmFunc("yes")
  };

  const handleChangeno = () => {
    setAccountActiveChange(false);
    userAccountDeactivateConfirmFunc("no")

  };

  return (
    <>
      <Dialog
        className="user-filter-popup manage-user-filter"
        sx={{ width: "100%" }}
        fullScreen={fullScreen}
        open={open}
        onClose={handleChangeno}
        aria-labelledby="responsive-dialog-title"
      >
        <Stack
          sx={{ p: "25px 25px", pb: "6px" }}
          direction="row"
          alignItems="center"
          spacing={2}
          justifyContent="space-between"
        >
          <Typography className="model-title">
          Account Deactivation 
          </Typography>
        </Stack>
        <Box sx={{ p: "0px 25px 0px 25px" }}>


        <p className="label">
        Are you sure you want to deactivate this user?
        This action will move any open billing statements associated with them to the 'Orphaned Bills'.
        </p>


          {/* <p className="label">
            Are you sure you want to{" "}
            {accountArchive ? " unarchive " : " archive "} this user?
          </p> */}
        </Box>
        <DialogActions
          sx={{ justifyContent: "flex-start", p: "20px 25px", pt: "21px" }}
        >
          <Button className="filter-btn" onClick={handleChangeyes}>
              Yes
            </Button>

          <Button className="cancel-btn" onClick={handleChangeno}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
